import {
  Box, Button, Chip, IconButton, Typography,
} from "@mui/material";
import { ArrowBack, Edit } from "@mui/icons-material";
import type { SiteHeaderView, SiteStatus } from "@/api/types";
import { SITE_STATUS_LABELS, formatSiteDisplayId } from "@/api/labels";

const STATUS_COLOR: Record<SiteStatus, "success" | "warning" | "default"> = {
  active: "success",
  start_up: "warning",
  closed: "default",
};

interface Props {
  site: SiteHeaderView;
  onBack: () => void;
  onEdit: () => void;
}

export function SiteHeader({ site, onBack, onEdit }: Props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 3 }}>
      <IconButton onClick={onBack} aria-label="Back to sites">
        <ArrowBack />
      </IconButton>
      <Box sx={{ flex: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          {site.display_id !== null && (
            <Typography
              variant="body2"
              sx={{
                fontFamily: "ui-monospace, Menlo, monospace",
                color: "text.secondary",
                bgcolor: "action.hover",
                px: 1,
                py: 0.25,
                borderRadius: 1,
              }}
            >
              #{formatSiteDisplayId(site.display_id)}
            </Typography>
          )}
          <Typography variant="h5">{site.common_name}</Typography>
          <Chip
            size="small"
            label={SITE_STATUS_LABELS[site.status]}
            color={STATUS_COLOR[site.status]}
          />
        </Box>
        {site.legal_entity_name && (
          <Typography variant="body2" color="text.secondary">
            {site.legal_entity_name}
          </Typography>
        )}
      </Box>
      <Button variant="outlined" startIcon={<Edit />} onClick={onEdit}>
        Edit
      </Button>
    </Box>
  );
}
